export default {
  key: "HrdcSettingsPrice",
  serviceKey: "hrdc",
  name: {
    singular: "Price",
    plural: "Price",
  },
  parents: [
    //
  ],
  add: {
    name: "Price",
  },
  view: {
    name: "Price",
  },
};
